import { NCmsComponentListing } from './cms-component-listing.interface';

export const isCustomRule = (data: NCmsComponentListing.IData) => data?.type !== 'page' || data?.matching === 'custom';

export const toJSONScopeData = (data: NCmsComponentListing.IData) => {
    return JSON.stringify(data, function (key, value) {
        if (typeof key === 'string') {
            if (key[0] === '_') {
                return undefined;
            }

            if (key === 'uniqueId') {
                return undefined;
            }
        }

        return value;
    });
};
